import React from 'react';
import Navbar from '../components/navbar';
import Banner from '../components/banner';
import Pagination from '../components/pagination';
import { base_url } from '../url';

const Home = () => {
  const dataUrl = `${base_url}/news/content/feed`;
  const articlesPerPage = 2;

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <Banner />
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="max-w-7xl mx-auto">
          <Pagination dataUrl={dataUrl} articlesPerPage={articlesPerPage} />
        </div>
      </main>
    </div>
  );
};

export default Home;
